<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div *ngIf="aircraftProfileAudits && aircraftProfileAudits.length > 0; else noAudits">
    <sd-portal-audit-detail-list
      (nextPage)="onNextPage()"
      [audits]="aircraftProfileAudits"
    ></sd-portal-audit-detail-list>
  </div>
  <ng-template #noAudits> No Aircraft Profile audits </ng-template>
</ng-template>
